<template>
<div>
    <div class="diagram-four-wrap" :style="{ height: winHeight - 100 + 'px' }" ref="total">
        <div id="main" ref="main" class="total-wrap">
            <div
                id="canvas"
                ref="canvas"
                class="canvas-wrap"
                :style="`transform: scale(${scale});width:${width};height:${height};top:${top}px;left:${left}px`"
            >
                <img class="bg-img" src="../../../../assets/image/app/xbj-03.svg" alt srcset />
                <!-- <div class="total-title">MO3#变系统图</div> -->
                  <div
                        v-for="item in mo_datas"
                        :key="item.point_id"
                        class="data-wrap"
                        :style="`top:${item.top}%;left:${item.left}%;`"
                        @click="showDialog(item)"
                    >
                        <div class="data-item">
                            <div class="data-name red">ia</div>
                            <div class="data-number">
                                {{ item.ia }}
                                <span>A</span>
                            </div>
                        </div>
                        <div class="data-item">
                            <div class="data-name yellow">ib</div>
                            <div class="data-number">
                                {{ item.ib }}
                                <span>A</span>
                            </div>
                        </div>
                        <div class="data-item">
                            <div class="data-name green">ic</div>
                            <div class="data-number">
                                {{ item.ic }}
                                <span>A</span>
                            </div>
                        </div>
                    </div> 
                    <div
                        v-for="item in mo_datas"
                        :key="item.switch_id"
                        class="top-switch"
                        :style="`top:${item._top}%;left:${item._left}%;`" @click="showTempDialog(item)"
                    >
                    <template v-if="item.isOn == 0">
                            <img
                               
                                src="../../../../assets/image/app/switch-on.svg"
                                alt
                                srcset
                                class="kaiguan"
                            />
                             </template>
                              <template v-else>
                                <img 
                                    src="../../../../assets/image/app/switch-off.svg"
                                    alt
                                    srcset
                                    class="kaiguan"
                                />
                            
                        </template> 
                    </div>   
            </div>
        </div>
         <diagramDialog :dialogVisible.sync="dialogVisible" :id="data_id" />
        <diagramDialog :dialogVisible.sync="dialogTempVisible" :id="switch_power_id" />
    </div>
</div>
</template>
<script>

import diagramDialog from "./components/diagram-dialog.vue";
import * as api from "@/http/api-runtime.js";
import { getNewestPower } from "@/http/api";
export default {
    components: { diagramDialog },
    data() {
        return {
           left: "0",
            top: "-20",
            scale:1,
            width: 1200,
            height: 1000,
            winHeight: 0,
            dialogVisible: false,
            dialogTempVisible: false,
            data_id: "",
            data_temp_id: "",
            switch_power_id: "",
            timer: null,
                mo_datas: [
                {
                    name: "403",
                    point_id: "1466645979766771712",
                    _top:11.6,//6
                    _left:4.94,//4.27
                    switch_id: "sunsu_000000000000050",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                    top:35,
                    left:2,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "4301",
                    point_id: "1466646130929487872",
                    _top:11.6,
                    _left:12.51,
                    switch_id: "sunsu_000000000000051",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                    top: 35,
                    left:10,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "4302",
                    point_id: "1466646282503245824",
                     _top:11.6,
                    _left:17.6,
                    switch_id: "sunsu_000000000000052",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                    top: 35,
                    left:15,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "4303",
                    point_id: "1466646573520834560",
                      _top:11.6,
                    _left:23.20,
                   switch_id: "sunsu_000000000000053",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                    top: 35,
                    left:21,
                    ia: "",
                    ib: "",
                    ic: ""
                }, 
                {
                    name: "4305",
                    point_id: "1466646995077746688",
                    _top:11.6,
                    _left:36.47,
                    switch_id: "sunsu_000000000000054",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                    top: 35,
                    left:34,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                 {
                    name: "4306",
                    point_id: "1466646842140839936",
                    _top:11.6,
                    _left:42.27,
                    switch_id: "sunsu_000000000000055",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                    top: 35,
                    left:40,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "4307",
                    point_id: "1466647356614168576",
                    _top: 11.6,
                    _left:48.68,
                    switch_id: "sunsu_000000000000056",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                    top: 35,
                    left:46,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "4308",
                    point_id: "1466648113547628544",
                    _top:11.6,
                    _left:54.1,
                   switch_id: "sunsu_000000000000057",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                    top:35,
                    left: 52,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                 {
                    name: "4309",
                    point_id: "1466648278132117504",
                    _top:11.6,
                    _left:59.62,
                    switch_id: "sunsu_000000000000058",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                    top:35,
                    left:57,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                 {
                    name: "4310",
                    point_id: "1466648564821184512",
                    _top:11.6,
                    _left:65.15,
                    switch_id: "sunsu_000000000000059",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                    top:35,
                    left:63,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                  {
                    name: "4311",
                    point_id: "1466649272383492096",
                    _top:11.6,
                    _left:70.63,
                    switch_id: "sunsu_000000000000060",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                    top: 35,
                    left:68,
                    ia: "",
                    ib: "",
                    ic: ""
                }, 
                 {
                    name: "4312",
                    point_id: "1466655702004051968",
                     _top:11.6,
                    _left:76.27,
                    switch_id: "sunsu_000000000000061",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                    top:35,
                    left:74,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "4313",
                    point_id: "1466655859370143744",
                     _top:11.6,
                    _left:82.07,
                    switch_id: "sunsu_000000000000062",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                    top:35,
                    left:80,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "4314",
                    point_id: "1466649621014040576",
                     _top:11.6,
                    _left:88.22,
                   switch_id: "sunsu_000000000000063",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                    top:35,
                    left:86,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                 {
                    name: "4315",
                    point_id: "1466649799364235264",
                     _top:11.6,
                    _left:94.35,
                    switch_id: "sunsu_000000000000064",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                   top:35,
                    left:92,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "4316",
                    point_id: "1466649898937012224",
                     _top:63.2,
                    _left:92.17,
                    switch_id: "sunsu_000000000000065",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                   top:88,
                    left:90,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                 {
                    name: "4317",
                    point_id: "1466649991454969856",
                     _top:63.2,
                    _left:85.67,
                    switch_id: "sunsu_000000000000066",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                   top:88,
                    left:84,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                
                 {
                    name: "4318",
                    point_id: "1466653269517447168",
                     _top:63.2,
                    _left:78.4,
                    switch_id: "sunsu_000000000000067",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                    top:88,
                    left:77,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                 {
                    name: "4319",
                    point_id: "1466653401503805440",
                    _top:63.2,
                    _left:71.38,
                    switch_id: "sunsu_000000000000068",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                    top:88,
                     left:69,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                 {
                    name: "4320",
                    point_id: "1466653551362093056", 
                    _top:63.2,
                    _left:64.35,
                    switch_id: "sunsu_000000000000069",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                     top:88,
                    left:62,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                 {
                    name: "4321",
                    point_id: "1466653687609864192",
                    _top:63.2,
                    _left:57.32,
                    switch_id: "sunsu_000000000000070",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                    top:88,
                    left:55,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                  {
                    name: "4322",
                    point_id: "1466653868719910912",
                    _top:63.2,
                    _left:50.7,
                    switch_id: "sunsu_000000000000071",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                    top:88,
                    left:48,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "4323",
                    point_id: "1466654059799818240",
                    _top:63.2,
                    _left:44.07,
                    switch_id: "sunsu_000000000000072",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                    top:88,
                    left:41,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "4324",
                    point_id: "1466654217631477760",
                    _top:63.2,
                    _left:37.33,
                   switch_id: "sunsu_000000000000073",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                    top:88,
                    left:35,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "4325",
                    point_id: "1466654368697724928",
                    _top:63.2,
                    _left:30.37,
                    switch_id: "sunsu_000000000000074",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                    top:88,
                    left:28,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "4326",
                    point_id: "1466654490785525760",
                    _top:63.2,
                    _left:23.67,
                    switch_id: "sunsu_000000000000075",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                    top:88,
                    left:21,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                 {
                    name: "4327",
                    point_id: "1466654625682731008",
                    _top:63.2,
                    _left:16.99,
                    switch_id: "sunsu_000000000000076",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                    top:88,
                    left:14,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                 {
                    name: "4328",
                    point_id: "1466654830771613696",
                    _top:63.2,
                    _left:10.77,
                   switch_id: "sunsu_000000000000077",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                    top:88,
                    left:8,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                 {
                    name: "4329",
                    point_id: "1466654939437641728",
                    _top:63.2,
                    _left:4.65,
                    switch_id: "sunsu_000000000000078",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                    top:88,
                    left:2,
                    ia: "",
                    ib: "",
                    ic: ""
                },
            ]

        };
    },
    created() {
        if (window.innerHeight) this.winHeight = window.innerHeight;
        else if (document.body && document.body.clientHeight)
            this.winHeight = document.body.clientHeight;
    },

    mounted() {
        this.zoom();
        this.drag();
         this.setTimer();
        // 获取mo实时电数据
        this.getMoElecData();
        // 获取mo实时温度数据
       //this.getMoTempData();
        //获取MO开关
        this.getWarnSwitch();
    },
     methods: {
          setTimer() {
            if (this.timer) {
                clearInterval(this.timer);
            }
            this.timer = setInterval(() => {
                // 获取mo实时电数据
                this.getMoElecData();
                // 获取mo实时温度数据
                //this.getMoTempData();
                 // 获取mo开关
                this.getWarnSwitch();
            }, 1000 * 60);
        },
        /**
        * @description: 获取mo实时电数据
        */
        getMoElecData() {
            let pointIds = [];
            this.mo_datas.forEach(item => {
                pointIds.push(item.point_id);
            });
            api.getDataAll(pointIds).then(res => {
                let valueJson = res.bus_json;
                this.mo_datas.forEach(item => {
                    let point = valueJson[item.point_id];

                    item.ia = point && point["a_a"] && this.fixedString(point["a_a"], 2);
                    item.ib = point && point["a_b"] && this.fixedString(point["a_b"], 2);
                    item.ic = point && point["a_c"] && this.fixedString(point["a_c"], 2);
                })
            })
        },
        
//开关开关
   getWarnSwitch() {
            let powerIds = [];
            this.mo_datas.forEach(item => {
                powerIds.push(item.switch_id);
            });
            api.getWarnSwitch(powerIds).then(res => {
                let valueJson = res.bus_json; 
                this.mo_datas.forEach(item => { 
                 let point = valueJson[item.switch_id];
                  item.isOn = point && point["kgl"];
                })
            })
        }, 

        /**
        * @description: 获取mo实时温度数据
        */
        // getMoTempData() {
        //     let pointIds = [];
        //     this.temp_datas.forEach(item => {
        //         pointIds.push(item.point_id);
        //     });
        //     api.getDataAll(pointIds).then(res => {
        //         let valueJson = res.bus_json;
        //         this.temp_datas.forEach(item => {
        //             let point = valueJson[item.point_id];
        //             item.ta = point && point["t_a"] && this.fixedString(point["t_a"], 0);
        //             item.tb = point && point["t_b"] && this.fixedString(point["t_b"], 0);
        //             item.tc = point && point["t_c"] && this.fixedString(point["t_c"], 0);
        //         })
        //     })
        // },
      
         
        /**
        * @description: 保留几位小数  number位数
        */
        fixedString(value, number) {
            let val = value + "";
            if (number == 0) {
                const arr = val.split(".");
                if (arr.length > 0) {
                    return arr[0];
                } else {
                    return "";
                }
            }
            return val.substring(0, val.indexOf(".") + (1 + number));

        },
        showDialog(item) {
            this.dialogVisible = true;
            this.data_id = item.point_id;
        },
        showTempDialog(item) {
            this.dialogTempVisible = true;
            this.switch_power_id = item.switch_id;  
        },
        zoom() {
            let vm = this;
            if (navigator.userAgent.indexOf("Firefox") != -1) {
                //FF
                document.getElementById("main").addEventListener(
                    "DOMMouseScroll",
                    function (event) {
                        event = event || window.event;
                        if (event.detail > 0) {
                            vm.scale =
                                vm.scale > 0.2 ? vm.scale - 0.1 : vm.scale;
                        } else {
                            vm.scale += 0.1;
                        }
                        event.cancelBubble = true;
                        event.stopPropagation();
                        event.preventDefault();
                    },
                    false
                );
            } else {
                //非FF
                document.getElementById("main").onmousewheel = function (event) {
                    event = event || window.event;
                    if (event.deltaY > 0) {
                        vm.scale = vm.scale > 0.2 ? vm.scale - 0.1 : vm.scale;
                    } else {
                        vm.scale += 0.1;
                    }
                    event.cancelBubble = true;
                    event.stopPropagation();
                    event.preventDefault();
                };
            }
        },
        drag() {
            let oDiv = this.$refs.canvas;
            let vm = this;
            oDiv.onmousedown = function (en) {
                let ev = ev || event;
                let disX = en.clientX - oDiv.offsetLeft;
                let disY = en.clientY - oDiv.offsetTop;
                oDiv.onmousemove = function (en) {
                    let ev = ev || event;
                    if (
                        en.clientY > 0 &&
                        en.clientY < vm.$refs.main.clientHeight &&
                        en.clientX > 0 &&
                        en.clientX < vm.$refs.main.clientWidth
                    ) {
                        vm.top = en.clientY - disY;
                        vm.left = en.clientX - disX;
                    }
                };
                oDiv.onmouseup = function () {
                    oDiv.onmousemove = null;
                };
                return false;
            };
        },
    },
       destroyed() {
        clearInterval(this.timer);
    }
};
</script>
<style lang="scss" scoped>
.diagram-four-wrap {
    background-color: #09292f;
    width: 98%;
    overflow: hidden;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    .total-wrap {
        width: 100%;
        height: 100%;
        position: relative;
        cursor: move;
        .canvas-wrap {
            width: 100%;
            position: absolute;
            left: 0;
            top: 0;
             box-sizing: border-box;
                  .bg-img {
                    width: 100%;
                    height: 100%;
                }
        } 
                .top-switch {
               cursor: pointer;
                transform: scale(1);
                position: absolute;
                text-align: center;
                display: flex;
               // height: 20%;
                overflow: hidden;

                .top-title {
                    align-self: center;
                    margin-left: 0.7rem;
                    font-size: 0.8rem;
                }
            }
        .total-title {
            color: #fff;
            position: absolute;
            font-size: 24px;
            text-align: center;
            top: 1%;
            left: 50%;
            transform: translateX(-50%);
        }
        .bg-img {
            width: 100%;
        }

        .data-wrap {
            position: absolute;
            display: grid;
            transform: scale(0.8);
            cursor: pointer;

            .data-item {
                display: flex;
                margin-bottom: 0.2rem;

                .data-name {
                    align-self: center;
                    font-size: 1rem;
                    margin-right: 0.1rem;
                    width: 1rem;
                    text-align: right;
                    font-weight: bold;
                }

                .data-number {
                    font-size: 0.8rem;
                    width: 5rem;
                    text-align: right;
                     background-color: #0e4b69;
                    color: #fff;
                    height: 1.2rem;
                    line-height: 1.2rem;
                //  margin-left: 0.4rem;
                    .nowrap span {
                        display: inline-block;
                        margin-left: 0.2rem;
                        margin-right: 0.2rem;
                    }
                }

                .red {
                    color: #fe0101;
                }

                .yellow {
                    color: #fefa00;
                }

                .green {
                    color: #00b200;
                }
            }
            .data-item-temp {
                display: flex;
                margin-bottom: 0.3rem;

                .data-name-temp {
                    align-self: center;
                    font-size: 1rem;
                    margin-right: 0.1rem;
                    width: 1rem;
                    text-align: right;
                    font-weight: bold;
                }
             
                .data-number-temp {
                    font-size: 0.8rem;
                    width: 5rem;
                    text-align: right;
                    // background-color: #114aa5;
                    color: #fff;
                    height: 1.2rem;
                    line-height: 1.2rem;

                    .nowrap span {
                        display: inline-block;
                        margin-left: 0.2rem;
                        margin-right: 0.2rem;
                    }
                }

                .red {
                    color: #fe0101;
                }

                .yellow {
                    color: #fefa00;
                }

                .green {
                    color: #00b200;
                }
            }
        }
    }
}
</style>
